export function containsWord(str: string, word: string) {
  return str.match(new RegExp("\\b" + word + "\\b")) !== null;
}
